import { render, staticRenderFns } from "./TableReutilizable.vue?vue&type=template&id=4ea39b81&scoped=true"
import script from "./TableReutilizable.vue?vue&type=script&lang=js"
export * from "./TableReutilizable.vue?vue&type=script&lang=js"
import style0 from "./TableReutilizable.vue?vue&type=style&index=0&id=4ea39b81&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ea39b81",
  null
  
)

export default component.exports